import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './DepartmentHead.css';

function DepartmentHead() {
    const profiles = Array(5).fill({
        name: 'Akinwande Daniel',
        position: 'Human Resources Director',
        image: '/images/akinwande.svg',
        linkedin: 'https://www.linkedin.com'
    });

    return (
        <section className="department-head py-5">
            <div className="container text-center">
                <h2 className="mb-5">Our Department Head</h2>
                <div className="row justify-content-center">
                    {profiles.map((profile, index) => (
                        <div className="col-md-4 mb-4 d-flex justify-content-center" key={index}>
                            <div className="card h-100">
                                <div className="row no-gutters">
                                    <div className="col-6">
                                        <img src={profile.image} alt={profile.name} className="card-img" />
                                    </div>
                                    <div className="col-6 d-flex flex-column">
                                        <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" className="ml-auto p-2">
                                            <img src='/images/linkedin-icon.svg' alt="LinkedIn" className="linkedin-icon" />
                                        </a>
                                        <h3 className="card-title p-2">{profile.name}</h3>
                                    </div>
                                </div>
                                <div className="card-body text-center">
                                    <p className="card-text font-weight-bold">{profile.position}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default DepartmentHead;